import * as THREE from "three";

const vertexShader = /* glsl */`
	varying vec2 vUv;
	void main() {
		vUv = uv;
		gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
	}
`;

const fragmentShader = /* glsl */`
	uniform vec2 uSize;
	uniform float uRadius;
	uniform vec3 uColor;
	uniform float uOpacity;
	varying vec2 vUv;
	float roundedBoxSDF(vec2 p, vec2 b, float r) {
		vec2 q = abs(p) - b + r;
		return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;
	}
	void main() {
		vec2 p = (vUv - 0.5) * uSize;
		float r = min(uRadius, min(uSize.x, uSize.y) * 0.45);
		float d = roundedBoxSDF(p, uSize * 0.5, r);
		if (d > 0.0) discard;
		gl_FragColor = vec4(uColor, uOpacity);
	}
`;

export type RoundedRectMaterialOptions = {
	radius?: number;
	color?: THREE.ColorRepresentation;
	opacity?: number;
};

export function CreateRoundedRectMaterial(opts: RoundedRectMaterialOptions = {}): THREE.ShaderMaterial {
	const {radius = 0, color = 0x000000, opacity = 0.5} = opts;
	return new THREE.ShaderMaterial({
		transparent: true,
		depthTest: false,
		uniforms: {
			uSize: {value: new THREE.Vector2(1, 1)},
			uRadius: {value: radius},
			uColor: {value: new THREE.Color(color)},
			uOpacity: {value: opacity},
		},
		vertexShader,
		fragmentShader,
	});
}

/** Updates the size uniform; call each frame after the mesh scale is set. */
export function SetRoundedRectSize(mat: THREE.ShaderMaterial, w: number, h: number): void {
	(mat.uniforms.uSize.value as THREE.Vector2).set(w, h);
}

/** Updates the corner radius uniform. */
export function SetRoundedRectRadius(mat: THREE.ShaderMaterial, radius: number): void {
	mat.uniforms.uRadius.value = radius;
}